import fetch,{getBlob} from '../utils/fetch';
export function findBusinessScoreList(params) {
    return fetch({
      method: 'POST',
      url: '/businessScore/findBusinessScoreList',
      data:params
    })
  }


  export function exportBusinessScoreList(params) {
    return getBlob({
      method: 'POST',
      url: '/businessScore/exportBusinessScoreList',
      data:params
    })
  }